module.exports = "<button translate class=\"btn {{ classes }}\"\n        [disabled]=\"loading || !valid\" \n        [ngClass]=\"{'loading': loading, 'processing': processing}\">\n  {{ title }}\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/relief-button/relief-button.component.html
// module id = ./src/app/shared/relief-button/relief-button.component.html
// module chunks = main